import { NavigationIconLink } from './NavigationLink'
import { Column } from '../common/pure/FlexContainer'
import TooltipWrapper from '../common/pure/TooltipWrapper'
import t from '../../tools/t'
import { useUserContext } from '../contexts/UserContext'

export type MainMenuOption = 'organization' | 'structure' | 'admin'

interface MainMenuItem {
    icon: PrimeIconName
    option: MainMenuOption
    tooltip: string
}
const MAIN_MENU: Array<MainMenuItem> = [
    {
        icon: 'th-large',
        option: 'organization',
        tooltip: t('common_organization'),
    },
    {
        icon: 'sitemap',
        option: 'structure',
        tooltip: t('common_structure'),
    },
    {
        icon: 'globe',
        option: 'admin',
        tooltip: t('common_admin'),
    },
]

interface MainMenuProps {
    selectedOption: MainMenuOption
    onOptionSelected: (option: MainMenuOption) => void
}
export default function MainMenu({ selectedOption, onOptionSelected }: MainMenuProps) {
    const { me } = useUserContext()
    const menu = me?.isAdmin ? MAIN_MENU : MAIN_MENU.filter((m) => m.option !== 'admin')
    return (
        <Column className="main-menu" alignment="center" gap={0.5}>
            {menu.map((item, i) => (
                <TooltipWrapper key={i} label={item.tooltip}>
                    <NavigationIconLink
                        selected={item.option === selectedOption}
                        icon={item.icon}
                        onClick={() => onOptionSelected(item.option)}
                    />
                </TooltipWrapper>
            ))}
        </Column>
    )
}
